"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = exports.listWidths = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../../util/GlobalScript.js");

var _Button = _interopRequireDefault(require("../../buttons/Button"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _underscore = _interopRequireDefault(require("underscore"));

var _FlexRow = _interopRequireWildcard(require("../../layout/FlexRow"));

var _FormRadioGroup = _interopRequireDefault(require("../FormRadioGroup"));

var _CheckboxGroup = _interopRequireDefault(require("../CheckboxGroup"));

var _FormSearchBox = _interopRequireDefault(require("../FormSearchBox"));

var _HelpHint = _interopRequireDefault(require("../../tooltips/HelpHint"));

var _v2Constants = require("./v2-constants");

var _SegmentedBox = _interopRequireWildcard(require("../../layout/SegmentedBox"));

var _PipeRow = _interopRequireWildcard(require("../../layout/PipeRow"));

var _Link = _interopRequireWildcard(require("../../general/Link"));

var _PropUtils = require("../../../util/PropUtils");

var _Stack = _interopRequireWildcard(require("../../layout/Stack"));

var _Text = _interopRequireWildcard(require("../../general/Text"));

var _FilterUtils = require("../../../util/FilterUtils");

var _listComponents, _listDataIdPostfix;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source), true)).call(_context6, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context7; (0, _forEach.default)(_context7 = ownKeys(Object(source))).call(_context7, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

/**
 * @enum {string}
 * @alias SelectionList.ListWidths
 */
var listWidths = _objectSpread(_objectSpread({}, _SegmentedBox.boxSizes), {}, {
  /** fixed */
  FIXED: "fixed",

  /** fluid */
  FLUID: "fluid",

  /** auto width */
  AUTOWIDTH: "autowidth",

  /** full width */
  FULL: "full"
});

exports.listWidths = listWidths;

var ValueList = function ValueList(_ref) {
  var dataId = _ref["data-id"],
      options = _ref.options;
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    gap: _Stack.gapSizes.SM,
    "data-id": dataId
  }, (0, _map.default)(options).call(options, function (_ref2, i) {
    var value = _ref2.value,
        label = _ref2.label,
        helpHintText = _ref2.helpHintText,
        _ref2$hint = _ref2.hint,
        hint = _ref2$hint === void 0 ? helpHintText : _ref2$hint;
    return /*#__PURE__*/_react.default.createElement(_FlexRow.default, {
      spacing: _FlexRow.spacingOptions.XS,
      key: i,
      "data-id": "value-item-".concat(value)
    }, /*#__PURE__*/_react.default.createElement("span", null, label), hint && /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
      hintText: hint,
      placement: "right"
    }));
  }));
};

var AddOptions = function AddOptions(_ref3) {
  var dataId = _ref3["data-id"],
      onValueChange = _ref3.onValueChange,
      options = _ref3.options;

  var valueChange = function valueChange(option) {
    return function (e) {
      return onValueChange(option, e);
    };
  };

  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    gap: _Stack.gapSizes.SM,
    "data-id": dataId
  }, (0, _map.default)(options).call(options, function (option) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      type: _Text.textTypes.VALUE,
      key: option.value,
      "data-id": ""
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      inline: true,
      iconName: "plus",
      "data-id": "row-button-add_".concat(option.value),
      onClick: valueChange(option),
      disabled: option.disabled
    }), option.label);
  }));
};

var itemProp = _propTypes.default.shape({
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  name: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool
});

var optionProp = _propTypes.default.shape({
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  label: _propTypes.default.node,
  disabled: _propTypes.default.bool
});

var listComponents = (_listComponents = {}, (0, _defineProperty3.default)(_listComponents, _v2Constants.ListType.ADD, AddOptions), (0, _defineProperty3.default)(_listComponents, _v2Constants.ListType.SINGLE, _FormRadioGroup.default), (0, _defineProperty3.default)(_listComponents, _v2Constants.ListType.MULTI, _CheckboxGroup.default), (0, _defineProperty3.default)(_listComponents, _v2Constants.ListType.MULTIADD, _CheckboxGroup.default), (0, _defineProperty3.default)(_listComponents, _v2Constants.ListType.VIEWONLY, ValueList), _listComponents);
var listDataIdPostfix = (_listDataIdPostfix = {}, (0, _defineProperty3.default)(_listDataIdPostfix, _v2Constants.ListType.ADD, "-add-options"), (0, _defineProperty3.default)(_listDataIdPostfix, _v2Constants.ListType.SINGLE, "-options-single-selection"), (0, _defineProperty3.default)(_listDataIdPostfix, _v2Constants.ListType.MULTI, "-options-multi-selection"), (0, _defineProperty3.default)(_listDataIdPostfix, _v2Constants.ListType.MULTIADD, "-options-multi-selection"), (0, _defineProperty3.default)(_listDataIdPostfix, _v2Constants.ListType.VIEWONLY, "-read-only"), _listDataIdPostfix);
/**
 * @name SelectionListStateless
 * @memberof SelectionList
 * @desc This is a wrapper around the stateful (stateless=true) SelectionList.
 */

var SelectionListStateless = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SelectionListStateless, _React$Component);

  var _super = _createSuper(SelectionListStateless);

  function SelectionListStateless() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, SelectionListStateless);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_selectAll", function () {
      _this.props.onSelectAll();

      if (_this.props.autoSelectAll) {
        var _context2;

        _this.props.onValueChange((0, _map.default)(_context2 = _this._getOptions()).call(_context2, function (_ref4) {
          var value = _ref4.value;
          return value;
        }));
      }
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_unselectAll", function () {
      return _this.props.onValueChange([]);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onShowOnlyAllToggle", function () {
      _this.props.onVisibilityChange();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_filterVisible", function () {
      return (0, _filter.default)(_underscore.default).call(_underscore.default, _this._getOptions(), function (item) {
        var _context3;

        return (0, _indexOf.default)(_context3 = _this.props.selectedItemIds).call(_context3, item.value) > -1;
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getSelectionOptions", function () {
      var itemsSelected = (0, _typeof2.default)(_this.props.selectedItemIds) === "object" ? _this.props.selectedItemIds.length : !!_this.props.selectedItemIds;
      return /*#__PURE__*/_react.default.createElement(_PipeRow.default, {
        "data-id": _this.props["data-id"],
        gap: _PipeRow.pipeGaps.SM,
        key: "selection-options"
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        "data-id": "show-only-or-all",
        onClick: _this._onShowOnlyAllToggle,
        size: _Link.linkSizes.SM
      }, _this.props.showOnlySelected ? _this.props.labelShowAll : _this.props.labelOnlySelected), itemsSelected || !_this.props.labelSelectAll ? /*#__PURE__*/_react.default.createElement(_Link.default, {
        "data-id": "unselect-all",
        onClick: _this._unselectAll,
        size: _Link.linkSizes.SM
      }, _this.props.labelUnselectAll) : /*#__PURE__*/_react.default.createElement(_Link.default, {
        "data-id": "select-all",
        onClick: _this._selectAll,
        size: _Link.linkSizes.SM
      }, _this.props.labelSelectAll));
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_renderMultiAddPanel", function () {
      var onClick = function onClick() {
        return _this.props.onMultiAdd(_this.props.selectedItemIds);
      };

      return /*#__PURE__*/_react.default.createElement(_FlexRow.default, {
        justify: _FlexRow.justifyOptions.CENTER,
        key: "add-panel"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "data-id": "add-button",
        label: _this.props.multiAddButtonLabel,
        disabledText: _this.props.multiAddButtonDisabledHint,
        disabled: !!_this.props.multiAddButtonDisabledHint,
        onClick: onClick,
        type: "primary"
      }));
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getOptions", function () {
      var _this$props = _this.props,
          autoFilter = _this$props.autoFilter,
          items = _this$props.items,
          _this$props$options = _this$props.options,
          options = _this$props$options === void 0 ? (0, _PropUtils.translateItemsToOptions)(items) : _this$props$options,
          queryString = _this$props.queryString;
      return autoFilter ? (0, _filter.default)(options).call(options, _underscore.default.partial(_FilterUtils.filterFieldContains, "label", queryString)) : options;
    });
    return _this;
  }

  (0, _createClass2.default)(SelectionListStateless, [{
    key: "render",
    value: function render() {
      var _context4, _context5;

      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          dataId = _this$props2["data-id"],
          name = _this$props2.name,
          noBorder = _this$props2["no-border"],
          onSearch = _this$props2.onSearch,
          onValueChange = _this$props2.onValueChange,
          optionsNote = _this$props2.optionsNote,
          queryString = _this$props2.queryString,
          removeMaxHeight = _this$props2.removeMaxHeight,
          renderList = _this$props2.renderList,
          requiredText = _this$props2.requiredText,
          searchBoxProps = _this$props2.searchBoxProps,
          searchPlaceholder = _this$props2.searchPlaceholder,
          selectedItemIds = _this$props2.selectedItemIds,
          showSearchBox = _this$props2.showSearchBox,
          showSelectionOptions = _this$props2.showSelectionOptions,
          type = _this$props2.type,
          width = _this$props2.width;
      var visibleOptions = this.props.showOnlySelected ? this._filterVisible() : this._getOptions();

      var selectionOptions = showSelectionOptions && this._getSelectionOptions(visibleOptions);

      var searchBox = showSearchBox ? /*#__PURE__*/_react.default.createElement("div", {
        "data-id": dataId + "-search-box",
        key: "search"
      }, /*#__PURE__*/_react.default.createElement(_FormSearchBox.default, (0, _extends2.default)({
        queryString: queryString,
        placeholder: searchPlaceholder,
        onValueChange: onSearch,
        width: "MAX",
        noSpacing: true
      }, searchBoxProps))) : null;
      var bottomPanel = type === _v2Constants.ListType.MULTIADD ? this._renderMultiAddPanel() : this.props.bottomPanel && /*#__PURE__*/_react.default.createElement("div", {
        key: "bottom-panel"
      }, this.props.bottomPanel);
      var renderedTopPanel = requiredText || searchBox || optionsNote ? [requiredText && /*#__PURE__*/_react.default.createElement(_SegmentedBox.SegmentedBoxMessage, {
        key: "message",
        "data-id": "".concat(dataId, "-required-message")
      }, requiredText), searchBox, optionsNote && /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: _Text.textTypes.NOTE,
        key: "note",
        "data-id": "options-note"
      }, optionsNote)] : null;
      var renderedBottomPanel = bottomPanel || selectionOptions ? [selectionOptions, bottomPanel] : null;
      return /*#__PURE__*/_react.default.createElement(_SegmentedBox.default, {
        "data-id": dataId,
        "scroll-box-data-id": "".concat(dataId, "-options"),
        className: className,
        width: (0, _includes.default)(_context4 = (0, _values.default)(_SegmentedBox.boxSizes)).call(_context4, width) && width || width === listWidths.FLUID && _SegmentedBox.boxSizes.SM || width === listWidths.FULL && "full" || width !== listWidths.AUTOWIDTH && _SegmentedBox.boxSizes.XS || "none",
        innerHeight: removeMaxHeight ? null : _SegmentedBox.boxSizes.XS,
        border: !noBorder,
        topPanel: renderedTopPanel,
        bottomPanel: renderedBottomPanel
      }, renderList({
        "data-id": (0, _concat.default)(_context5 = "".concat(dataId)).call(_context5, listDataIdPostfix[type]),
        groupName: name || "input-selection-list-items-".concat(dataId),
        stacked: true,
        disabled: disabled,
        queryString: queryString,
        onValueChange: onValueChange,
        options: visibleOptions,
        value: selectedItemIds,
        values: selectedItemIds,
        selected: selectedItemIds,
        setCheckboxDataId: function setCheckboxDataId(option, index) {
          return "selectionList-Checkbox-".concat(index + 1);
        } // backwards compatibility

      }, listComponents[type]));
    }
  }]);
  return SelectionListStateless;
}(_react.default.Component);

exports.default = SelectionListStateless;
(0, _defineProperty3.default)(SelectionListStateless, "displayName", "SelectionListStateless");
(0, _defineProperty3.default)(SelectionListStateless, "propTypes", {
  autoSelectAll: _propTypes.default.bool,
  autoFilter: _propTypes.default.bool,
  bottomPanel: _propTypes.default.node,
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  items: _propTypes.default.arrayOf(itemProp),
  labelSelectAll: _propTypes.default.string,
  labelUnselectAll: _propTypes.default.string,
  labelOnlySelected: _propTypes.default.string,
  labelShowAll: _propTypes.default.string,
  name: _propTypes.default.string,
  "no-border": _propTypes.default.bool,
  multiAddButtonLabel: _propTypes.default.string,
  multiAddButtonDisabledHint: _propTypes.default.string,
  onValueChange: _propTypes.default.func,
  onSelectAll: _propTypes.default.func,
  onSearch: _propTypes.default.func.isRequired,
  queryString: _propTypes.default.string,
  onVisibilityChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(optionProp),
  optionsNote: _propTypes.default.node,
  onMultiAdd: _propTypes.default.func,
  removeMaxHeight: _propTypes.default.bool,
  renderList: _propTypes.default.func,
  requiredText: _propTypes.default.string,
  showSelectionOptions: _propTypes.default.bool,
  showOnlySelected: _propTypes.default.bool,
  showSearchBox: _propTypes.default.bool,
  searchPlaceholder: _propTypes.default.string,
  selectedItemIds: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.string, _propTypes.default.number]),
  type: _propTypes.default.oneOf((0, _values.default)(_v2Constants.ListType)),
  width: _propTypes.default.oneOf((0, _values.default)(listWidths))
});
(0, _defineProperty3.default)(SelectionListStateless, "defaultProps", {
  "data-id": "selection-list",
  renderList: _PropUtils.defaultRender,
  showSearchBox: true,
  type: _v2Constants.ListType.SINGLE,
  showSelectionOptions: false,
  showOnlySelected: false,
  items: [],
  "no-border": false,
  multiAddButtonLabel: "Add",
  onMultiAdd: _underscore.default.noop,
  onValueChange: _underscore.default.noop,
  onSelectAll: _underscore.default.noop,
  autoSelectAll: false,
  autoFilter: false
});